/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const pharmacyDispenseLines = sqliteTable('pharmacy_dispense_lines', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  pharmacy_dispense_id: text('pharmacy_dispense_id'),
  invoice_item_id: text('invoice_item_id'),
  prescription_line_id: text('prescription_line_id'),
  inventory_item_id: text('inventory_item_id'),
  inventory_batch_id: text('inventory_batch_id'),
  item_name_snapshot: text('item_name_snapshot'),
  sku_snapshot: text('sku_snapshot'),
  batch_number_snapshot: text('batch_number_snapshot'),
  expiry_date_snapshot: text('expiry_date_snapshot'),
  unit_snapshot: text('unit_snapshot'),
  instructions_snapshot: text('instructions_snapshot'),
  quantity_to_dispense: real('quantity_to_dispense'),
  quantity_dispensed: real('quantity_dispensed'),
  status: text('status'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
